import * as types from "./actionTypes";
import securityApi from "../api/shared/securityApi";
import * as ajax from "./ajaxCounterActions";
import * as exception from "./exceptionActions";
import redirector from "../util/redirector";
import { showToastrError } from "../util/toastr";
import * as messages from "../constants/ToastrConstants";

export function authorizationInfoLoaded(authorizationInfo) {
    return {
        type: types.AUTHORIZATION_INFO_LOADED,
        body: authorizationInfo
    };
}

export function aanmeldCodeInvalid(error) {
    return {
        type: types.INVALID_AANMELDCODE,
        error: error
    };
}

export function accountIdInvalid(error) {
    return {
        type: types.INVALID_ACCOUNT_ID,
        error: error
    };
}

export function loadAuthorizationInfo() {
    return function (dispatch) {
        dispatch(ajax.started());
        //get once to check if user is known
        return securityApi.getAuthorizationInfo()
            .then((response) => {
                if (response.statusCode === 401) {
                    redirector.goTo('/noAccess');
                }
                dispatch(ajax.ended());
                if (!response.data || typeof response.data === 'string')
                    dispatch(exception.throwException("No valid authorization info from api"));
                else {
                    dispatch(authorizationInfoLoaded(response.data));
                }
            })
            .catch(error => {
				if (error && error.response && error.response.status === 401) {
					redirector.goTo('/noAccess');
					dispatch(ajax.failed());
					return;
				}

                dispatch(ajax.failed());
                dispatch(exception.throwException(error, true));
            });
    };
}

export function authorizeSpoVlaMedewerker(accountId, organisatieType) {
    return function (dispatch) {
        dispatch(ajax.started());

        return securityApi.authorizeSpoVlaMedewerker(accountId, organisatieType)
            .then((response) => {
                dispatch(ajax.ended());

                if (response.statusCode === 401) {
                    redirector.goTo('/noAccess');
                    return;
                }

                if (!response.data || typeof response.data === 'string') {
                    dispatch(exception.throwException("No valid authorization info from api"));
                    return;
                }

                if (response.data.hasValidationErrors) {
                    dispatch(accountIdInvalid(response.data.validationResults.isAllowed));
                    showToastrError(messages.MESSAGE_VALIDATION_ERRORS);

                    return;
                }

                dispatch(authorizationInfoLoaded(response.data));
            })
            .catch(error => {
                if (error.response.status === 404) {
                    dispatch(ajax.ended);
                    dispatch(accountIdInvalid('Dit account ID bestaat niet voor het geselecteerde organisatietype.'));
                    showToastrError(messages.MESSAGE_ERROR);
                } else {
                    dispatch(ajax.failed());
                    dispatch(exception.throwException(error, true));
                }
            });
    };
}
